import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { colors } from "@mui/material";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");
  // console.log(user,"running")

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "इनाम",
      entry: "प्रवेश शुल्क",
    },
    en: {
      view: "view",
      entry: "Entry Fee ",
      prize: "Winning Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme  = localStorage.getItem('theme')

  const styles = {
    color: theme === "light" ? "black" : "black",
  };

  return (
    <div className={`${css.betCard} mt-1 battle_card_main card_bottom_border`}>
      <div className="px-3 py-2" style={{ background: "linear-gradient(90deg, #1b4b76 0%, #4ec6d1 100%)", color: "#fff" }}>
        <div className="d-flex align-items-center justify-content-between">
          <span className="font-weight-bold" style={{ fontSize: "13px" }}>
            Playing For
          </span>
          <span className="ml-2" style={{ fontSize: "13px", fontWeight: 700 }}>
            {runnig.Created_by?.Name?.length > 5 ? `${runnig.Created_by.Name.slice(0, 5)}...` : runnig.Created_by?.Name}
            <span className="mx-1">&</span>
            {runnig.Accepetd_By?.Name?.length > 5 ? `${runnig.Accepetd_By.Name.slice(0, 5)}...` : runnig.Accepetd_By?.Name}
          </span>
        </div>
      </div>
      <div className="py-2 row battle_card_inner_bottom runing-padding align-items-center">
        <div className="pr-3 text-center col-5">
          <span className={css.betCardSubTitle} style={{ color: "#4b5563" }}>
            {translations[language].entry}
          </span>
          <div className="d-flex align-items-center justify-content-center mt-1">
            <img className="mx-1" src="/images/moneyrupee.png" alt="" width="20" height="20" />
            <span className={css.betCardAmount} style={{ color: "#1b4b76", fontSize: "20px", marginLeft: "2px" }}>
              {runnig.Game_Ammount}
            </span>
          </div>
        </div>
        <div className="pr-3 text-center col-2 cxy" style={{ top: "10px" }}>
          {user == runnig.Accepetd_By._id || user == runnig.Created_by._id ? (
            <Link
              className={`${css.bgSecondary} ${css.playButton} ${css.cxy} position-relative mx-1 ${runnig.Status == "conflict" ? "bg-danger" : "bg-success"}`}
              style={{ right: "0px", top: "0px", padding: "8px 14px", borderRadius: "999px" }}
              to={{
                pathname: `/viewgame1/${runnig._id}`,
                state: { prevPath: window.location.pathname },
              }}
            >
              {translations[language].view}
            </Link>
          ) : (
            <img
              className="mx-1 verses mb-2"
              src={process.env.PUBLIC_URL + "/images/Homepage/gamepad.png"}
              alt=""
              width="24"
              height="24"
            />
          )}
        </div>
        <div className="text-center col-5">
          <span className={css.betCardSubTitle} style={{ color: "#4b5563" }}>
            {translations[language].prize}
          </span>
          <div className="d-flex align-items-center justify-content-center mt-1">
            <img className="mx-1" src="/images/moneyrupee.png" alt="" width="20" height="20" />
            <span className={css.betCardAmount} style={{ color: "#2e7d32", fontSize: "20px" }}>
              {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
